import ShopPage from './ShopPage';
import ShopPageContainer from './ShopPage.container';

export default ShopPageContainer(ShopPage);
